const catalogSearchInput = document.querySelector('.catalog-search__input')
const catalogSearchBtn = document.querySelector('.catalog-search__btn')

catalogSearchInput.addEventListener('input', event => {
  // let length = catalogSearchInput.value.length
  let checkSpaces = catalogSearchInput.value.trim() !== ''
  if (checkSpaces) {
    catalogSearchBtn.classList.add('catalog-search__btn--find')
  } else {
    catalogSearchBtn.classList.remove('catalog-search__btn--find')
  }
})
